import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import {
  dubaiHotels,
  dubaiTours,
  dubaiTransfers,
  dubaiVisa,
} from "../data/data";
import { Star, Clock, Users, CheckCircle } from "lucide-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/tabs";

const Cyprus = () => {
  const { language, t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-yellow-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-slate-900 to-slate-800 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4 text-center">
            {t("cyprusSpecial")}
          </h1>
          <p className="text-xl text-gray-300 text-center max-w-2xl mx-auto">
            {t("cyprusSubTitle")}
          </p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-16">
        <Tabs defaultValue="hotels" className="w-full">
          <TabsList className="grid w-full grid-flow-col auto-cols-fr mb-12 bg-white shadow-md rounded-xl p-2">
            <TabsTrigger
              value="hotels"
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-yellow-600 data-[state=active]:text-white rounded-lg font-semibold transition-all duration-300"
            >
              {t("cyprusHotels")}
            </TabsTrigger>

            <TabsTrigger
              value="transfer"
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-yellow-600 data-[state=active]:text-white rounded-lg font-semibold transition-all duration-300"
            >
              {t("cyprusTransfer")}
            </TabsTrigger>

          </TabsList>

          {/* Hotels Tab */}
          <TabsContent value="hotels">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {dubaiHotels.map((hotel) => (
                <a
                  key={hotel.id}
                  href={hotel.website || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={hotel.image}
                      alt={hotel.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center space-x-1">
                      <Star className="h-4 w-4 fill-amber-400 text-amber-400" />
                      <span className="font-semibold text-gray-900">
                        {hotel.stars}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {hotel.name}
                    </h3>
                    <p className="text-gray-600 mb-4">
                      {hotel.description[language]}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </TabsContent>



          {/* Transfer Tab */}
          <TabsContent value="transfer">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {dubaiTransfers.map((transfer) => (
                <div
                  key={transfer.id}
                  className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={transfer.image}
                      alt={transfer.name[language]}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {transfer.name[language]}
                    </h3>
                    <div className="flex items-center space-x-2 text-gray-500 mb-4">
                      <Users className="h-4 w-4" />
                      <span className="text-sm">
                        {language === "tr" ? "Kapasite" : "Capacity"}:{" "}
                        {transfer.capacity}{" "}
                        {language === "tr" ? "kişi" : "people"}
                      </span>
                    </div>
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div>
                        <span className="text-3xl font-bold text-amber-600">
                          ${transfer.price}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabsContent>

          {/* Visa Tab */}

        </Tabs>
      </div>
    </div>
  );
};

export default Cyprus;
